<template>
    <div class="agent-nav nav" v-if="geoData && geoData.length > 0">
        <ul class="crumbs mvt-breadcrumb hidden-xs" >
            <component :is="'script'" type="application/ld+json" v-text="breadCrumbSchema"></component>
            <li v-for="item in geoData">
                <a v-if="!item.disable" class="link" :href="item.url">{{item.name}}</a>
                <span v-else>{{item.name}}</span>
            </li>
       </ul>
       <div class="dap-buttons">
           <a class="link" :href="'tel:' + dap.phone" v-if="dap.phone && isMovotoAgent"><i class="icon-phone-o"></i> Call</a>
           <a class="link" @click="openHotlead" v-if="isMovotoAgent"><i class="icon-envelope-o"></i> Message</a>
           <a class="link write-review" v-if="!isAgent" @click="openReview"><i class="icon-star-o"></i> Write Review</a>
           <a class="link" @click="openSendEmail"><i class="icon-share"></i> Share</a>
        </div>
    </div>
 </template>

 <script src="./agent-nav.js"></script>

 <style lang="scss">
 @use './agent-nav.scss' as *;
 </style>
